import { HStack, RadioGroup } from "@chakra-ui/react"
import InteractiveTooltip from "../shared/InteractiveTooltip"
import RoleBadge from "../shared/RoleBadge"

function RadioPill({ value, onChange, label, color, disabled, tooltip }) {
  function handleClick(item) {
    // Treat like button when checked to trigger change event.
    if (item.checked) {
      onChange(value)
    }
  }

  const pill = (
    <RadioGroup.Item value={value} disabled={disabled}>
      <RadioGroup.ItemHiddenInput />
      <RadioGroup.ItemContext>
        {(item) => (
          <RoleBadge
            label={label}
            color={color}
            highlight={item.checked}
            disabled={disabled}
            onClick={() => handleClick(item)}
          />
        )}
      </RadioGroup.ItemContext>
    </RadioGroup.Item>
  )

  if (disabled && tooltip) {
    return <InteractiveTooltip label={tooltip}>{pill}</InteractiveTooltip>
  }

  return pill
}

const RadioPills = ({ options, value, onChange, name }) => {
  return (
    <RadioGroup.Root
      asChild
      name={name}
      defaultValue={options[0]?.key}
      value={value}
      onValueChange={(e) => {
        onChange(e.value)
      }}
    >
      <HStack align="center" justify="center" flexWrap="wrap">
        {options.map((option) => (
          <RadioPill
            key={option.key}
            value={option.key}
            label={option.label}
            color={option.color}
            disabled={option.disabled}
            tooltip={option.tooltip}
            onChange={onChange}
          />
        ))}
      </HStack>
    </RadioGroup.Root>
  )
}

export default RadioPills
